import { FC } from 'react';
import { Stack } from '@mui/material';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FormikValues } from 'formik';
import InputControl from '@/components/form/input-control';

interface Props {
  formHandle: FormHandle<FormikValues>;
  readonly: boolean;
}

const IntentForm: FC<Props> = ({ formHandle, readonly }) => {
  return (
    <Stack gap={2}>
      <InputControl type="text" name="name" label="Name" formHandle={formHandle} autoFocus />
      <InputControl
        type="textarea"
        name="description"
        label="Description"
        readonly={readonly}
        formHandle={formHandle}
      />
      <InputControl
        name="enabled"
        label="Enabled"
        type="switch"
        formHandle={formHandle}
        readonly={readonly}
      />
    </Stack>
  );
};

export default IntentForm;
